import * as React from 'react';
import clsx from 'clsx';
import styles from './bullets.module.css';

interface Props {
  list: ReadonlyArray<{
    title: string;
    text: string;
  }>;
  className?: string;
  itemStyle?: string;
}

function Bullets({ list, className, itemStyle }: Props) {
  return (
    <ul className={clsx(styles.list, className)}>
      {list.map((e) => (
        <li key={e.title} className={clsx(styles.item, itemStyle)}>
          <h4 className={styles.title} dangerouslySetInnerHTML={{ __html: e.title }} />
          <p className={styles.text} dangerouslySetInnerHTML={{ __html: e.text }} />
        </li>
      ))}
    </ul>
  );
}

export default Bullets;
